import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getAboutPageData = async () => {
  const data = await fetchData(ENDPOINTS.GET.ABOUT, {
    method: METHODS.GET,
  });
  return data;
};
